// extracted by mini-css-extract-plugin
export default {"root":"TopologyActions_root__D9KNc","action":"TopologyActions_action__KObTM"};